import { useState } from 'react';

/**
 * Open state a caller may take over.
 *
 * A form overlay reached from a page's mobile actions drawer has to be driven
 * from outside: the drawer must finish closing before the overlay opens, or two
 * overlays stack and the body is left with a stuck pointer-events lock. Passing
 * neither argument keeps the component's own state, so `trigger` call sites are
 * unaffected.
 *
 * @example
 * const [open, setOpen] = useControllableOpen(openProp, onOpenChange);
 */
export function useControllableOpen(open?: boolean, onOpenChange?: (open: boolean) => void) {
    const [internalOpen, setInternalOpen] = useState(false);

    const setOpen = (next: boolean) => {
        setInternalOpen(next);
        onOpenChange?.(next);
    };

    return [open ?? internalOpen, setOpen] as const;
}
